export const colorNamesExterior = [
  "SUPERSONIC RED",
  "HEAVY METAL",
  "OXYGEN WHITE",
  "MAGNETIC GRAY",
  "BLACK",
  "OXYGEN WHITE WITH BLACK",
  "HEAVY METAL WITH BLACK BI-TONE",
  "SUPERSONIC RED WITH BLACK BI-TONE",
  "BRONZE AGE WITH BLACK BI-TONE",
];
export const colorNamesInterior = [
  "BLACK LEATHER",
  "MACADAMIA LEATHER",
  "BLACK DARK CHESTNUT LEATHER",
];
